import React, { useMemo, useState } from 'react';
import { IconChevron } from '../../assets/icons';
import { DialogSwitcher, SwitcherOptionType } from '../dialog';
import { InputMui } from '../input-mui/input-mui';
import './index.scss';

type InputSwitcherProps = {
  options: SwitcherOptionType[];
  defaultOptionIndex?: number;
  label: string;
  disabled?: boolean;
  onChange?: (target: HTMLInputElement) => void;
};

export const InputSwitcher: React.FC<InputSwitcherProps> = ({
  options,
  defaultOptionIndex = 0,
  label,
  disabled = false,
  onChange,
}) => {
  const [showSelectDialog, setShowSelectDialog] = useState<boolean>(false);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState<number>(defaultOptionIndex);

  const onClick = () => setShowSelectDialog(true);

  const dialogOnChange = (optionIndex: number) => {
    setSelectedOptionIndex(optionIndex);
    setShowSelectDialog(false);

    onChange?.({ value: options[optionIndex].value } as HTMLInputElement);
  };

  const option = useMemo(() => options[selectedOptionIndex], [options, selectedOptionIndex]);

  return (
    <>
      <InputMui
        value={option.label}
        label={label}
        readOnly
        disabled={disabled}
        endIcon={<IconChevron direction="right" noSpace />}
        onClickInput={onClick}
        startIcon={option.icon}
      />
      <DialogSwitcher
        show={showSelectDialog && !disabled}
        setShow={setShowSelectDialog}
        title={label}
        options={options}
        selectedOptionIndex={selectedOptionIndex}
        onChange={dialogOnChange}
      />
    </>
  );
};
